import React from 'react';
import { motion } from 'framer-motion';
const galleryItems = [{
  label: 'Nombres decorativos',
  img: 'https://cdn.magicpatterns.com/uploads/kpX7CG6zagdn5aEFtR7tMG/CREA_NOMBRES.jpg',
  crop: 'object-cover object-center'
}, {
  label: 'Flores y detalles especiales',
  img: 'https://cdn.magicpatterns.com/uploads/ozwxh1m9PDCQxyWD7r6hV6/image.png',
  crop: 'object-cover object-center'
}, {
  label: 'Decoración para cuartos infantiles',
  img: 'https://cdn.magicpatterns.com/uploads/o4YVWyQaLMM64d9Ckg1Rcy/image.png',
  crop: 'object-cover object-center'
}, {
  label: 'Souvenirs para eventos',
  img: 'https://cdn.magicpatterns.com/uploads/5Z8CS7qkg6yjFwe7CVU7PG/souvenirs.webp',
  crop: 'object-cover object-center'
}, {
  label: 'Regalos personalizados',
  img: 'https://cdn.magicpatterns.com/uploads/jDBnfrVJWqrAMogQJ4QHqt/regalos_personalizados.jpg',
  crop: 'object-cover object-center'
}, {
  label: 'Ideas listas para vender',
  img: 'https://cdn.magicpatterns.com/uploads/26tbvApC1LXPNsh1rZZu29/image.png',
  crop: 'object-cover object-center'
}];
export function Gallery() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-[#FFF9F3]" data-id="element-77">
      <div className="max-w-7xl mx-auto" data-id="element-78">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12" data-id="element-79">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl text-brand-text mb-4 font-bold" data-id="element-80">
            Mirá todo lo que podes crear con Tricotín
          </h2>
          <p className="text-base sm:text-lg text-brand-text/80 font-normal" data-id="element-81">
            Proyectos hermosos, personalizados y con muchísimo valor para
            regalar, decorar o vender
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 lg:gap-8" data-id="element-82">
          {galleryItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group relative rounded-2xl sm:rounded-[2rem] overflow-hidden aspect-square bg-brand-sand shadow-sm border-2 sm:border-4 border-white" data-id="element-83">
              <img src={item.img} alt={item.label} className={`w-full h-full ${item.crop} transition-transform duration-700 group-hover:scale-105`} data-id="element-84" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-text/80 via-brand-text/30 to-transparent opacity-90" data-id="element-85" />
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6" data-id="element-86">
                <p className="text-white font-serif text-sm sm:text-xl font-medium sm:font-[500] leading-tight" data-id="element-87">
                  {item.label}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}